import { SelectBase } from "@/util/selector"

export const CM_DATES_ARG = {
  DATE: 'date',
  ID: 'id',
}

export default class CMDateModel {
  constructor(item = {}) {
    this.date = item[CM_DATES_ARG.DATE]
  }
}

export class CMDateSelectable extends SelectBase {
  constructor(item = {}) {
    super()
    this.item = item
    this.date = item.date
    this.ID = item.ID
    this.candidatesCount = item.candidatesCount
    this.topCbrQueueCount = item.topCbrQueueCount
    this.mijnCbrQueueCount = item.mijnCbrQueueCount
    this.topCbrExchangeQueueCount = item.topCbrExchangeQueueCount
    this.topCbrReserveQueueCount = item.topCbrReserveQueueCount
    this.maxSlots = item.maxSlots
    this.maxStudents = item.maxStudents
    this.slotsCount = item.slotsCount
    this.name = item.name
  }
}